import { Directive, HostListener, ElementRef, OnInit, Input } from '@angular/core';

@Directive({
    selector: '[appDigitOnly]'
})
export class DigitOnlyDirective implements OnInit {


    inputElement: HTMLElement;
    constructor(public el: ElementRef) {
        this.inputElement = el.nativeElement;
    }

    ngOnInit() {
        this.inputElement = this.el.nativeElement;
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {

        if (this.isValidKey(e)) {
            return;
        }

        if (
            (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
            (e.keyCode < 96 || e.keyCode > 105)
        ) {
            e.preventDefault();
        }

    }

    @HostListener('paste', ['$event'])
    onPaste($event) {
        let clipboardData;
        if (window['clipboardData']) {
            $event.preventDefault();
            clipboardData = window['clipboardData'];
            const pastedInput: string = clipboardData
                .getData('Text')
                .replace(/\D/g, '');
            this.inputElement.focus();
            this.inputElement.innerText = pastedInput;
        } else {
            const e = $event as ClipboardEvent;
            e.preventDefault();
            clipboardData = e.clipboardData;
            const pastedInput: string = clipboardData
                .getData('text/plain')
                .replace(/\D/g, '');
            this.inputElement.focus();
            document.execCommand('insertText', false, pastedInput);
        }
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        event.preventDefault();
        const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
        this.inputElement.focus();
        document.execCommand('insertText', false, textData);
    }

    isValidKey(e: KeyboardEvent) {
        if (
            [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            (e.keyCode === 65 && e.ctrlKey === true) ||
            (e.keyCode === 67 && e.ctrlKey === true) ||
            (e.keyCode === 86 && e.ctrlKey === true) ||
            (e.keyCode === 88 && e.ctrlKey === true) ||
            (e.keyCode === 65 && e.metaKey === true) ||
            (e.keyCode === 67 && e.metaKey === true) ||
            (e.keyCode === 86 && e.metaKey === true) ||
            (e.keyCode === 88 && e.metaKey === true) ||
            (e.keyCode >= 35 && e.keyCode <= 39)
        ) {
            return true;
        }
        return false;
    }

}
